import { env } from 'src/config/env';
import { useEffect, useRef } from 'react';
import { User } from 'src/types/user.types';
import { useGetUsers } from 'src/queries/users';
import { usePaywall } from 'src/contexts/PaywallContext';
import { isDebugMode } from 'src/contexts/DebugContext';
import { computeFamilyGroupProperties } from 'src/modules/analytics/familyGroup';
import {
  familyGroupPropertiesSentFor,
  updatePosthogFamilyGroup,
} from 'src/modules/analytics/posthogClient';

export const useFamilyGroupIdentify = (currentUser?: User): void => {
  const { data: roster } = useGetUsers({ enabled: !!currentUser });
  const { activeSubscription } = usePaywall();
  const lastSent = useRef<string>('');

  useEffect(() => {
    if (env.isCi || isDebugMode()) return;
    if (!currentUser?.family || !roster || roster.length === 0) return;

    const familyId = String(currentUser.family_id);
    const props = computeFamilyGroupProperties(roster, currentUser.family, {
      activeSubscriptionId: activeSubscription?.identifier,
      now: new Date(),
    });
    const serialized = JSON.stringify(props);
    // A `posthog.reset()` (logout) wipes the pushed marker but leaves this ref alone — this
    // component stays mounted across a same-family re-login.
    if (serialized === lastSent.current && familyGroupPropertiesSentFor() === familyId) return;
    if (updatePosthogFamilyGroup(familyId, props)) {
      lastSent.current = serialized;
    }
  }, [currentUser, roster, activeSubscription]);
};
